export function getDataLabel(index: number, label: string): string {
  return `${label}-${index}`;
}
